// extracted by mini-css-extract-plugin
export default {"container":"LocationSearch__container___2EhNF","input":"LocationSearch__input___2G8zT"};